import {Directive} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {TIYN_TENGE_SCALE_FACTOR} from '../infra/constants';
import {FloatNumberInputDirective} from './float-number-input.directive';

@Directive({
    selector: 'input[commonsTiynTengeInput]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: TiynTengeInputDirective,
            multi: true,
        },
    ],
    standalone: false
})
export class TiynTengeInputDirective extends FloatNumberInputDirective {

    writeValue(value: number | null): void {
        super.writeValue(this.tiynToTenge(value));
    }

    registerOnChange(fn: (value: number | null) => void): void {
        super.registerOnChange(value => fn(this.tengeToTiyn(value)));
    }

    private tiynToTenge(value: number | null): number {
        return value != null ? parseFloat((value / TIYN_TENGE_SCALE_FACTOR).toFixed(2)) : null;
    }

    private tengeToTiyn(value: number): number | null {
        return value != null ? parseFloat((value * TIYN_TENGE_SCALE_FACTOR).toFixed(2)) : null;
    }
}
